<template>
  <div class="register">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" :md="step == 3 ? '7' : '4'">
          <div class="px-5 mb-5 mx-auto">
            <img src="logo.png" alt="Logo" />
          </div>

          <h1>Regístrate</h1>

          <v-progress-circular
            :size="50"
            v-if="
              this.$store.state.register.isLoading &&
              !this.$store.state.register.isInvalid
            "
            color="primary"
            indeterminate
          >
          </v-progress-circular>

          <v-form
            ref="formRegister"
            v-if="!this.$store.state.register.isLoading"
          >
            <div class="px-8 mb-8" v-if="step == 1">
              <h3 class="font-weight-light mt-3">Datos básicos</h3>

              <v-text-field
                label="Primer Nombre"
                type="text"
                v-model="model.first_name"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Segundo Nombre"
                type="text"
                v-model="model.second_name"
              ></v-text-field>

              <v-text-field
                label="Primer Apellido"
                type="text"
                v-model="model.surname"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Segundo Apellido"
                type="text"
                v-model="model.second_surname"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Cédula"
                type="text"
                v-model="model.colombian_id"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Ciudad de expedición"
                type="text"
                v-model="model.expedition_city"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Teléfono"
                type="text"
                v-model="model.phone"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Dirección"
                type="text"
                v-model="model.address"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Correo"
                type="text"
                v-model="model.email"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.email,
                ]"
              ></v-text-field>

              <v-text-field
                label="Crea tu contraseña"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                v-model="model.password"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Confirmar contraseña"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                v-model="model.password_confirmation"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>
            </div>

            <div class="px-8 mb-8" v-if="step == 2">
              <h3 class="font-weight-light mt-3">Datos complementarios</h3>

              <v-select
                :items="this.$store.state.status.bloodTypes"
                label="Tipo de sangre"
                type="text"
                v-model="model.blood_type"
                :rules="[this.$store.state.rules.required]"
              ></v-select>

              <v-menu
                v-model="menuDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="model.birthday"
                    label="Fecha de nacimiento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="model.birthday"
                  @input="menuDate = false"
                  color="secondary"
                ></v-date-picker>
              </v-menu>

              <v-text-field
                label="Eps"
                type="text"
                v-model="model.eps"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Pensión"
                type="text"
                v-model="model.pension"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Operador de pila (seguridad social)"
                type="text"
                v-model="model.stack_operator"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>

              <v-text-field
                label="Correo segundario"
                type="text"
                v-model="model.second_email"
                :rules="[this.$store.state.rules.email]"
              ></v-text-field>

              <v-text-field
                label="Teléfono fijo"
                type="text"
                v-model="model.landline"
                :rules="[this.$store.state.rules.required]"
              ></v-text-field>
            </div>

            <div class="px-8 mb-8" v-if="step == 3">
              <h3 class="font-weight-light mt-3">Documentos</h3>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Foto"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.photo_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Propuesta"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.proposal_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Rut actualizado (fecha superior a Septiembre 2020)"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.rut_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Hoja de vida con foto"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.cv_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Soportes de hoja de vida"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.cv_supports_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Cedula Legible"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.colombian_id_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Antecedentes Fiscales expedido por la Contraloría General de la República"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_criminal_records_by_Comptroller_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Antecedentes Fiscales Expedido por la Procuraduría General de la República"
                :rules="[this.$store.state.rules.required]"
                v-model="
                  model.certificate_criminal_records_by_attorney_office_file
                "
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Consulta de antecedentes Policía Nacional"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_criminal_records_by_police_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Consulta de Medidas correctivas expedido por la Policía Nacional"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_corrective_measures_by_police_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificación Bancaria Actualizada"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_bank_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Examen Médico Ocupacional vigente"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.medical_exams_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Afiliación a EPS vigente"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_eps_file"
              ></v-file-input>

              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Certificado de Afiliación a AFP (pensión)"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_afp_file"
              ></v-file-input>




              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Redam"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_redam_file"
              ></v-file-input>
              
              <v-file-input
                accept="application/pdf,application/vnd.ms-excel,image/*,.doc,.docx,.pdf"
                label="Delitos sexuales"
                :rules="[
                  this.$store.state.rules.required,
                  this.$store.state.rules.max_file,
                ]"
                show-size
                v-model="model.certificate_sexual_file"
              ></v-file-input>
              
 
              <v-checkbox
                v-model="agreeTerm"
                color="indigo"
                value="red"
                hide-details
              >
                <template v-slot:label>
                  <div>
                    Acepto
                    <a
                      target="_blank"
                      href="/tratamiento_datos_personales"
                      @click.stop
                    >
                      Política de Tratamiento de Datos personales
                    </a>
                  </div>
                </template>
              </v-checkbox>
            </div>

            <v-btn color="secondary" rounded block large @click="nextStep">
              Continuar
            </v-btn>

            <v-btn color="secondary" text v-if="step > 1" @click="step -= 1">
              Atrás
            </v-btn>

            <br v-if="step > 1" />

            <v-btn
              color="accent"
              text
              class="register__btn_already_user"
              href="/login"
            >
              Ya estoy registrado
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import { SET_ALERT } from "@/store/alert";
export default {
  name: "register",
  data() {
    return {
      showPassword: false,
      menuDate: false,
      step: 1,
      agreeTerm: false,
      model: {
        //Data user
        email: "",
        password: "",
        first_name: "",
        second_name: "",
        surname: "",
        second_surname: "",
        colombian_id: "",
        phone: "",
        address: "",
        //Data employee
        blood_type: "",
        birthday: "",
        eps: "",
        pension: "",
        stack_operator: "",
        second_email: "",
        landline: "",
        expedition_city: "",
        //Files
        rut_file: [],
        cv_file: [],
        cv_supports_file: [],
        colombian_id_file: [],
        certificate_criminal_records_by_Comptroller_file: [],
        certificate_criminal_records_by_attorney_office_file: [],
        certificate_criminal_records_by_police_file: [],
        certificate_corrective_measures_by_police_file: [],
        certificate_bank_file: [],
        medical_exams_file: [],
        certificate_eps_file: [],
        certificate_afp_file: [],
        certificate_redam_file: [],
        certificate_sexual_file: [],
        proposal_file: [],
        photo_file: [],
      },
    };
  },
  methods: {
    nextStep() {
      if (this.step == 3) {
        this.register();
      } else {
        this.step += 1;
      }
    },
    register() {
      if (!this.agreeTerm) {
        this.$store.commit(SET_ALERT, {
          message:
            "Debe aceptar la política de Tratamiento de Datos personales",
          type: "info",
        });
        return;
      }
      if (this.$refs.formRegister.validate()) {
        this.$store.dispatch("register", this.createFormData());
      } else {
        this.step = 1;
        this.$store.commit(SET_ALERT, {
          message: "Todos los campos son obligatorios",
          type: "info",
        });
      }
    },
    createFormData() {
      let formData = new FormData();
      Object.entries(this.model).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((element, index) => {
            formData.append(key + "[" + index + "]", element);
          });
        } else {
          formData.append(key, value);
        }
      });
      return formData;
    },
  },
};
</script>

<style>
.register {
  height: 100%;
}

.register__btn_already_user {
  text-transform: none;
  letter-spacing: normal;
  font-size: 0.85rem;
  margin: 1.5rem 0;
}

.register__btn_already_user :hover {
  background: none;
}

.v-list-item__title {
  text-align: left !important;
}
</style>
